import { render, staticRenderFns } from "./Auto-add.vue?vue&type=template&id=2e258f5d&"
import script from "./Auto-add.vue?vue&type=script&lang=js&"
export * from "./Auto-add.vue?vue&type=script&lang=js&"
import style0 from "./Auto-add.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports